import { render, staticRenderFns } from "./InsightList.vue?vue&type=template&id=5f33b622&scoped=true&"
import script from "./InsightList.vue?vue&type=script&lang=js&"
export * from "./InsightList.vue?vue&type=script&lang=js&"
import style0 from "./InsightList.vue?vue&type=style&index=0&id=5f33b622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f33b622",
  null
  
)

export default component.exports